import { createFileRoute, Link } from "@tanstack/react-router";
import { useCallback } from "react";

import { PageHeader } from "../../components/shell/app-shell";
import { buttonClassName } from "../../components/ui/button-styles";
import { PaymentDocuments, paymentsSearchSchema, type PaymentsSearch } from "./-components/payment-documents";

export const Route = createFileRoute("/finance/payables")({
	validateSearch: paymentsSearchSchema,
	head: () => ({ meta: [{ title: "Payables · Finance · Ravnar" }] }),
	staticData: { crumbs: ["Finance", "Payables"] },
	component: PayablesPage,
});

function PayablesPage() {
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	const onSearch = useCallback(
		(next: PaymentsSearch) => {
			void navigate({ search: next, replace: true });
		},
		[navigate],
	);
	return (
		<>
			<PageHeader
				title="Payables"
				description="This year's bills and reimbursement claims: what is still to pay, and what is paid."
				actions={
					<Link to="/finance" className={buttonClassName({ size: "md" })}>
						Back to Finance
					</Link>
				}
			/>
			<PaymentDocuments side="payables" search={search} onSearch={onSearch} />
		</>
	);
}
